import { SignIn, SignUp } from "@clerk/react";
import { Logo } from "@/components/AppLayout";
import { HERO_IMG } from "@/lib/labels";

export default function AuthPage({ mode }) {
  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex relative overflow-hidden bg-slate-950">
        <img src={HERO_IMG} alt="" className="absolute inset-0 w-full h-full object-cover opacity-80" />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/30 to-transparent" />
        <div className="relative z-10 mt-auto p-12 text-white">
          <p className="eyebrow !text-amber-400">WindWorkHub.com</p>
          <p className="mt-3 text-3xl font-extrabold max-w-md leading-tight">Your experience, visible to companies across the wind industry.</p>
        </div>
      </div>
      <div className="flex flex-col items-center justify-center p-4 py-10 gap-8">
        <Logo />
        {mode === "in"
          ? <SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp />
          : <SignUp routing="path" path="/sign-up" signInUrl="/sign-in" />}
      </div>
    </div>
  );
}
